import type { RawWoodSpeciesItem } from "../rawWoodInputInformationSpecies";
import type { LogEntry } from "../rawWoodInputMeasurementLogs";
import isEqual from "lodash/isEqual";

export function speciesChanged(
  current: RawWoodSpeciesItem[],
  initial: RawWoodSpeciesItem[]
) {
  // Empty UI rows and their generated IDs are not inventory data.
  current = current.filter((row) => row.id && row.id !== "non");
  initial = initial.filter((row) => row.id && row.id !== "non");
  if (current.length !== initial.length) return true;
  for (let i = 0; i < current.length; i++) {
    const a = current[i];
    const b = initial[i];

    if (a.id !== b.id) return true;
    if (a.mix !== b.mix) return true;
  }
  return false;
}

export function logRowsChanged(current: LogEntry[], initial: LogEntry[]) {
  const savedIds = new Set(initial.map((row) => row.id));
  const normalize = (rows: LogEntry[]) => rows
    // The editor appends a blank row and reserves its ID automatically.
    .filter((row) => savedIds.has(row.id) || row.length || row.diameter || row.diameter2)
    .map((row) => ({
      id: row.id,
      uniqueMeasurementId: row.uniqueMeasurementId,
      species: row.species,
      length: row.length,
      diameter: row.diameter,
      diameter2: row.diameter2 || "",
      qClass: row.qClass,
    }));
  // Volume, loading and validation errors are derived UI state.
  return !isEqual(normalize(current), normalize(initial));
}
